import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant, IconName } from '@as/cotopaxi';
export const ProductSustainabilityTabCTA = ({ url, text }) => (_jsx(Button, { fill: true, variant: ButtonVariant.SUSTAINABLE, iconRight: { name: IconName.CHEVRON_RIGHT }, href: url, text: text }));
